import { createContext, useContext, useState, useCallback } from "react";
import type { ReactNode } from "react";

export interface PageContextInfo {
  /** Current page type */
  page:
    | "home"
    | "services"
    | "service-detail"
    | "application-form"
    | "track"
    | "help"
    | "guide"
    | "about"
    | "other";
  /** Service slug if on a service-related page */
  serviceSlug?: string;
  /** Service name if on a service-related page */
  serviceName?: string;
}

interface PageContextValue {
  pageContext: PageContextInfo;
  setPageContext: (ctx: PageContextInfo) => void;
}

const PageContext = createContext<PageContextValue>({
  pageContext: { page: "other" },
  setPageContext: () => {},
});

export function PageContextProvider({ children }: { children: ReactNode }) {
  const [pageContext, setPageContextState] = useState<PageContextInfo>({
    page: "other",
  });

  const setPageContext = useCallback((ctx: PageContextInfo) => {
    setPageContextState(ctx);
  }, []);

  return (
    <PageContext.Provider value={{ pageContext, setPageContext }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageContext() {
  return useContext(PageContext);
}
